<template>
  <section class="careers">
    <nav data-aos="fade-down" :class="['navbar navbar-expand-md', { sticky: isSticky }]">
      <div class="container transition-mode-bg">
        <svg class="svg left transition-mode-color" width="22" height="26" viewBox="0 0 22 26"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0.931314 0.736328H21.6426V25.1321C21.2863 9.29344 15.6873 1.4416 0.931314 0.736328Z"
            fill="currentColor" />
        </svg>
        <svg class="svg right transition-mode-color" width="22" height="26" viewBox="0 0 22 26"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0.931314 0.736328H21.6426V25.1321C21.2863 9.29344 15.6873 1.4416 0.931314 0.736328Z"
            fill="currentColor" />
        </svg>
        <router-link class="navbar-brand" to="/">
          <MgrLogoComponent />
        </router-link>
        <div class="toggle-collapse">
          <button class="toggle-mode-sm d-md-none d-flex" @click="toggleTheme">
            <i :class="theme === 'dark'
              ? 'ti ti-toggle-left-filled'
              : 'ti ti-toggle-right-filled'
              "></i>
          </button>
          <button class="navbar-toggler" :class="[{ open: isopen }]" type="button" data-bs-toggle="collapse"
            data-bs-target="#menuItems" aria-controls="menuItems" :aria-expanded="isExpanded"
            aria-label="Toggle navigation" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div class="collapse navbar-collapse" id="menuItems">
          <ul class="navbar-nav ms-auto gap-2">
            <p class="title-menu-nav d-md-none d-flex">MENU</p>
            <svg class="d-md-none d-flex" width="300" height="141" viewBox="0 0 300 141" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6 0.786621C2.68555 0.786621 0 3.47314 0 6.78662V134.787C0 138.1 2.68555 140.787 6 140.787H294C297.314 140.787 300 138.1 300 134.787V49.7866C300 46.4729 297.314 43.7866 294 43.7866H220C216.686 43.7866 214 41.1003 214 37.7866V6.78662C214 3.47291 211.314 0.786621 208 0.786621H6Z"
                fill="currentColor" />
            </svg>
            <li class="nav-item">
              <router-link class="nav-link" exact-active-class="active" to="/">
                <span class="btn-text-one">Home</span>
                <span class="btn-text-two">Home</span>
              </router-link>
            </li>
            <li class="nav-item">
              <div class="framer-epfdzp" style=""></div>
              <router-link class="nav-link" exact-active-class="active" to="/Careers">
                <span class="btn-text-one">Careers</span>
                <span class="btn-text-two">Careers</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- begin hero section -->
    <div class="careers-hero-section">
      <div class="container">
        <div class="img">
          <div class="career-hero-text">
            <span class="badge-title">We're Hiring</span>
            <p class="title">Bekerja, Berkembang, Menginspirasi</p>
            <p class="description">
              Kami mencari talenta yang ingin berkembang dan menciptakan dampak.
              Temukan peluang untuk meraih kesuksesan bersama kami.
            </p>
          </div>
          <img src="@/assets/img/hero-careers.png" alt="" />
          <div class="overlay-hero-careers"></div>
        </div>
      </div>
    </div>
    <!-- end hero section -->
    <!-- begin content career -->
    <div class="contentCareer" :style="{ marginBottom: emptyState ? '33rem' : '43rem' }">
      <div class="container">
        <div class="content">
          <!-- begin list career -->
          <div class="list-career" v-if="!emptyState && !selectedCareer">
            <div class="item-career">
              <div class="card transition-mode-bg-border" v-for="career in listCareer" :key="career.id"
                @mousemove="moveButton" @mouseenter="enterCard" @mouseleave="leaveCard">
                <div class="card-career">
                  <div class="job-header">
                    <div class="img-brand">
                      <img class="transition-mode-filter" :src="`${BASE_URL}/${career.logo}`" alt="" />
                    </div>
                    <div class="job-info">
                      <p class="store-name transition-mode-color">
                        {{ career.name_product }}
                      </p>
                      <p class="position-name transition-mode-color">
                        {{ career.posisi }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="job-detail">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge-career primary transition-mode-bg-border">
                      <i class="ti ti-map-pin-filled me-1 transition-mode-color"></i>
                      <span class="transition-mode-color">{{
                        career.lokasi_penempatan
                      }}</span>
                    </span>
                    <span class="badge-career danger transition-mode-bg-border">
                      <i class="ti ti-calendar-month me-1 transition-mode-color"></i>
                      <span class="transition-mode-color">
                        Batas: {{ career.akhir_posting }}
                      </span>
                    </span>
                  </div>

                </div>
                <a href="javascript:void(0)" class="btn-career-show-sm" @click="viewDetail(career.id)">
                  Detail
                </a>

                <a href="javascript:void(0)" class="btn-career" @click="viewDetail(career.id)"
                  ref="btn-career">Detail</a>
              </div>
            </div>
          </div>
          <!-- end  list career -->

          <div class="career-detail" v-if="selectedCareer">
            <div class="header-detail-career">
              <button class="btn" @click="clearDetail">
                <span>Kembali</span>
                <!-- SVG ikon -->
              </button>
              <div class="left">
                <img class="transition-mode-filter" :src="`${BASE_URL}/${selectedCareer.logo}`" alt="" />
                <div class="text-header">
                  <p class="position_detail">{{ selectedCareer.posisi }}</p>
                  <p class="desc_career_detail">{{ selectedCareer.name_product }}</p>
                  <p class="end_post">Batas Akhir: {{ selectedCareer.akhir_posting }}</p>
                </div>
              </div>
            </div>
            <div class="body-detail-career transition-mode-bg">

              <div class="mb-4" v-if="selectedCareer.kualifikasi">
                <span class="category-detail-career">Kualifikasi</span>
                <div class="mt-2">
                  <div v-for="(item, index) in kualifikasiList" :key="index" class="d-flex align-items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style="margin-top: 2px;"
                      viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5">
                        <rect width="16.5" height="16.5" x="3.75" y="3.75" rx="4" />
                        <path d="m16.512 9.107l-5.787 5.786l-3.237-3.232" />
                      </g>
                    </svg>
                    <span class="transition-mode-color">{{ item }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-4" v-if="selectedCareer.benefit">
                <span class="category-detail-career">Benefit</span>
                <div class="mt-2">
                  <div v-for="(item, index) in benefitList" :key="index" class="d-flex align-items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style="margin-top: 2px;"
                      viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5">
                        <rect width="16.5" height="16.5" x="3.75" y="3.75" rx="4" />
                        <path d="m16.512 9.107l-5.787 5.786l-3.237-3.232" />
                      </g>
                    </svg>
                    <span class="transition-mode-color">{{ item }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="selectedCareer.lokasi_penempatan">
                <span class="category-detail-career">Lokasi Penempatan</span>
                <div class="mt-2">
                  <div class="d-flex align-items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style="margin-top: 2px;"
                      viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5">
                        <rect width="16.5" height="16.5" x="3.75" y="3.75" rx="4" />
                        <path d="m16.512 9.107l-5.787 5.786l-3.237-3.232" />
                      </g>
                    </svg>
                    <span class="transition-mode-color">{{ selectedCareer.lokasi_penempatan }}</span>
                  </div>
                </div>
              </div>
              <div class="payroll transition-mode-color" v-if="selectedCareer.gaji">
                <span class="title-detail">Gaji :</span>
                <span class="content-detail">{{ selectedCareer.gaji }}</span>
              </div>
              <div class="work-time transition-mode-color" v-if="selectedCareer.jam_kerja">
                <span class="title-detail">Jam Kerja :</span>
                <span class="content-detail">{{ selectedCareer.jam_kerja }}</span>
              </div>
            </div>
            <div class="footer-detail-career transition-mode-bg">
              <span class="title-footer-career">Kirim Lamaran</span>
              <table class="transition-mode-color">
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td style="padding-left: 10px;">{{ selectedCareer.email }}</td>
                </tr>
                <tr>
                  <td>Whatsapp</td>
                  <td>:</td>
                  <td style="padding-left: 10px;">
                    <a class="transition-mode-color" :href="'https://wa.me/' + selectedCareer.whatsapp" target="_blank">
                      {{ selectedCareer.whatsapp }}
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- begin empty career -->
          <div class="empty-career" v-if="emptyState">
            <div class="content">
              <img src="@/assets/img/no-careers.png" alt="" />
              <p class="title-empty">
                Oops! Sepertinya tidak ada lowongan kerja di sini
              </p>
              <p class="desc-empty">
                Saat ini tidak ada lowongan kerja yang dapat ditampilkan.
              </p>
            </div>
          </div>
          <!-- end empty career -->
        </div>
      </div>
    </div>
    <!-- end content career -->
    <!-- begin background gradient footer -->
    <div class="bg-footer">
      <div class="content">
        <div class="footer-gradient"></div>
        <img src="@/assets/img/illustration.png" alt="" />
      </div>
    </div>
    <!-- end background gradient footer -->
  </section>
</template>

<script>
import { BASE_URL } from "@/path";
import { EventBus } from "@/EventBus";
import MgrLogoComponent from "@/components/MgrLogoComponent.vue";
import { toggleMixin } from "@/mixins/toggleMixin";
import api from "@/api";
export default {
  components: { MgrLogoComponent },
  name: "CareersView",
  mixins: [toggleMixin],
  data() {
    return {
      isSticky: false,
      isExpanded: false,
      isopen: false,
      emptyState: false,
      smoothButtonX: 0,
      smoothButtonY: 0,
      isCursorInsideCard: false,
      listCareer: [],
      selectedCareer: null,
      BASE_URL,
      theme: localStorage.getItem("theme") || "light",
    };
  },
  mounted() {
    EventBus.$on("themeChanged", (theme) => (this.theme = theme));
    window.addEventListener("scroll", this.handleScroll);

    const storedCareer = sessionStorage.getItem("careerDetail");
    if (storedCareer) {
      this.selectedCareer = JSON.parse(storedCareer);
    } else {
      this.getCareer();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    formattedWhatsapp() {
      return this.selectedCareer.whatsapp.replace(/^62/, "0");
    },
    kualifikasiList() {
      return this.selectedCareer?.kualifikasi?.split('\n') || [];
    },
    benefitList() {
      return this.selectedCareer?.benefit?.split('\n') || [];
    }
  },
  methods: {
    clearDetail() {
      this.getCareer();
      this.selectedCareer = null;
      sessionStorage.removeItem('careerDetail');
    },
    viewDetail(id) {
      const careerData = this.listCareer.find((item) => item.id === id);
      if (careerData) {
        sessionStorage.setItem("careerDetail", JSON.stringify(careerData));
        this.selectedCareer = careerData;
      }
    },
    handleScroll() {
      const offset = 20;
      this.isSticky = window.scrollY > offset;
    },
    async getCareer() {
      try {
        const response = await api.get("Landing/carier");
        const data = response.data.data;
        this.listCareer = data;
      } catch (error) {
        // console.error('Error fetching data:', error);
        this.emptyState = true;

      }
    },

    moveButton(event) {
      if (this.isCursorInsideCard) {
        const cardRect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - cardRect.left;
        const y = event.clientY - cardRect.top;

        this.smoothButtonX += (x - this.smoothButtonX) * 0.1;
        this.smoothButtonY += (y - this.smoothButtonY) * 0.1;

        const btn = event.currentTarget.querySelector(".btn-career");
        if (btn) {
          btn.style.left = `${this.smoothButtonX}px`;
          btn.style.top = `${this.smoothButtonY}px`;
        }
      }
    },

    enterCard() {
      this.isCursorInsideCard = true;
      this.$emit("cursor-enter", false);
    },
    leaveCard() {
      this.isCursorInsideCard = false;
      this.$emit("cursor-enter", true);
    },
  },
};
</script>